import { render, staticRenderFns } from "./EleFormSwitch.vue?vue&type=template&id=4edda1a4&"
import script from "./EleFormSwitch.vue?vue&type=script&lang=js&"
export * from "./EleFormSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports